import { router } from "./Router";
import { initializeSentry } from "./config/sentry";
import "./css/index.css";
import "./css/table.css";
import { initializePosthog } from "@app/config/posthog/posthog";
import theme from "@app/config/theme/theme";
import { MantineProvider } from "@mantine/core";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

initializeSentry();
const posthog = initializePosthog();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Failed to find the root element");
}

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={theme}>
      <PostHogProvider client={posthog}>
        <RouterProvider router={router} />
      </PostHogProvider>
    </MantineProvider>
  </StrictMode>
);
